/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { connect } from 'react-redux';
import Header from '../header/Header';
import GuestHeader from '../header/GuestHeader';
import Footer from '../footer/Footer';
import FooterForSEO from '../footer/FooterForSEO';
import { updateSubHeaderHeight, updateSubHeaderLogoHeight } from '../../../actions/webMetaData';
import { getSeoFooterData } from '../../../utils/plpMetaInfo.js';
import AppContainer from '../../../AppContainer';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { toggleStoreNav } from '../../../actions/webMetaData';
import { getStreetFlags } from '../../../refresh/selectors/featureFlagsSelector';
import { STREET_STORE } from '../../../constants/constant';
import ScrollToTop from "react-scroll-to-top";
import { segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import { getPageInfo } from '../../../utils/pageInfo';
class SISLayout extends React.Component {
  constructor(props) {
    super(props);
    this._scrollResizeEffect = this.scrollResizeEffect.bind(this);
    this.subHeaderHeight = {
      min: 70,
      max: 100,
      offsetHeight: 300
    };
    this.lastScroll = 0;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._scrollResizeEffect);
  }

  componentDidMount() {
    window.addEventListener('scroll', this._scrollResizeEffect);

    window.addEventListener('load', () => {
      const srFocus = document.getElementById('sr-init-focus');
      if (srFocus) {
        srFocus.focus({ preventScroll: true });

        const skipLink = document.getElementById('skip-link');
        if (skipLink) {
          skipLink.focus({ preventScroll: true });
        }
      }
    });
  }

  scrollResizeEffect() {
    let {
      metaData: { subHeaderHeight = 0, current: { navigation = [] } = {} } = {},
      isStreet = false
    } = this.props;
    let distanceY = window.pageYOffset || document.documentElement.scrollTop;

    if (distanceY > this.subHeaderHeight.offsetHeight && this.lastScroll < distanceY) {
      this.props.updateNewHeight(isStreet ? 0 : this.subHeaderHeight.min);
      this.props.updateSubHeaderLogoHeight(24);
      this.lastScroll = distanceY;
    } else if (distanceY < this.subHeaderHeight.offsetHeight && this.lastScroll > distanceY) {
      this.props.updateNewHeight(isStreet ? 0 : this.subHeaderHeight.max);
      this.props.updateSubHeaderLogoHeight(35);
      this.lastScroll = 0;
    }
  }

  render() {
    const {
      header = true,
      footerSeo = false,
      metaData: { sis = false, name = '', subHeaderHeight = 0, primaryHeaderHeight = 100 } = {},
      isFooter = true,
      hidePromiseIconsRowInFooter = false,
      isStreet = false,
      children = []
    } = this.props;

    let marginTop = isStreet ? primaryHeaderHeight : primaryHeaderHeight + subHeaderHeight;
    const { category = true, metaElementData = [] } = this.props;
    const bottomDescrip = getSeoFooterData(metaElementData, 'bottomDesc');
    const seoFooterDataPresent =
      bottomDescrip !== '' && bottomDescrip !== null && bottomDescrip !== undefined;
    const newDesignLuxe = this.props.newDesignLuxe;

    return (
      <div
        className={`${sis && !isStreet && `${name} store-in-store`} ${
          newDesignLuxe ? 'luxe-newdesign' : ''
        } ${isStreet ? 'street-store' : ''}`}
      >
        <AppContainer>
          <div
            id="sr-init-focus"
            tabIndex="-1"
            style={{
              position: 'absolute',
              left: `-9999px`,
              height: `1px`,
              width: `1px`,
              overflow: `hidden`
            }}
          />
          {children[1]?.props?.match?.path === '/my-account/:page' && (
            <a
              className="skip-link"
              tabIndex={0}
              onClick={() => {
                // const page = children[1]?.props?.match?.params?.page;
                const targetElement = document.querySelector('#right-dev-container-accounts');
                const targetElement1 = document.querySelector('.right-dev-container-accounts');
                if (targetElement) {
                  targetElement.focus();
                  targetElement.tabIndex = '-1';
                }
                if (targetElement1) {
                  targetElement1.focus();
                  targetElement1.tabIndex = '-1';
                }
              }}
            >
              Skip To Content
            </a>
          )}
          {header && <Header category={category} />}
          <div
            className="content"
            style={newDesignLuxe ? { marginTop: '165px' } : { marginTop: `${marginTop}px` }}
            role={children[1]?.props?.match?.path === "/my-account/:page" ? null : "main"}
          >
            {this.props.children}
          </div>
          {footerSeo && <FooterForSEO />}
          {isFooter && (
            <Footer hidePromiseIconsRowInFooter={hidePromiseIconsRowInFooter} />
          )}
          <ScrollToTop
            className='go-to-top-button'
            style={{height:"45px", width: "45px", bottom: "60px", backgroundColor: "#fff", right: "18px"}}
            smooth
            onClickCapture={
              e =>{
                segmentEventPush({
                  event:'Back To Top Clicked', 
                  screen_name: getPageInfo(window.location.href)
                })
              }
            }
          />
        </AppContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { productsAdditionalInfo = {}, metaData = {}, flags } = state;
  const { metaElementData = [] } = productsAdditionalInfo;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const { isThemeEnableWeb } = getStreetFlags(state);

  return {
    metaElementData,
    metaData,
    newDesignLuxe,
    isStreet: isThemeEnableWeb === 'ON' && storeName === STREET_STORE
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateNewHeight: (height, subLogoHeight) => {
      dispatch(updateSubHeaderHeight(height, subLogoHeight));
    },
    updateSubHeaderLogoHeight: subLogoHeight => {
      dispatch(updateSubHeaderLogoHeight(subLogoHeight));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SISLayout);
